import { useEffect, useState } from 'react';
import './dark.css';

/* Light / Dark / System, saved per browser and set as data-ps-theme on <html> so every v3 root follows it. */

export type Theme = 'light' | 'dark' | 'system';
const KEY = 'ps.theme';
const EVENT = 'ps-theme';

export function getTheme(): Theme {
    try {
        const v = window.localStorage.getItem(KEY);
        return v === 'dark' || v === 'system' ? v : 'light';
    } catch {
        return 'light';
    }
}

function apply(theme: Theme) {
    document.documentElement.dataset.psTheme = theme;
}

export function setTheme(theme: Theme) {
    try {
        if (theme === 'light') window.localStorage.removeItem(KEY);
        else window.localStorage.setItem(KEY, theme);
    } catch {
        /* storage blocked — applies for this page only */
    }
    apply(theme);
    window.dispatchEvent(new Event(EVENT));
}

/* before first paint of any v3 screen */
apply(getTheme());

export function useTheme() {
    const [theme, set] = useState<Theme>(getTheme);
    useEffect(() => {
        const on = () => set(getTheme());
        window.addEventListener(EVENT, on);
        return () => window.removeEventListener(EVENT, on);
    }, []);
    return [theme, setTheme] as const;
}
